<!-- break-words is load-bearing: the raw gegevensbeschermingsautoriteit.be URLs below
     are unbreakable tokens that pushed this page to 545px on a 390px phone, so the whole
     document scrolled sideways. max-w-prose caps the measure at 65 characters; at
     max-w-3xl the lines ran to ~92 and the eye loses the next line on the return. -->
<div class="mx-auto max-w-prose px-4 py-8 break-words">
  <h1 class="page-title text-2xl font-bold text-fg">Privacyverklaring</h1>
  <p class="text-left mt-2">
    spinningwesterlo.be (hierna: "De Aanbieder") vindt het garanderen van de
    privacy en de bescherming van gegevens erg belangrijk. Met deze
    privacyverklaring (hierna “Privacyverklaring”) wilt de Aanbieder de
    gebruiker in detail informeren over de verwerking van zijn/haar
    persoonsgegevens en bijhorende rechten bij het gebruik van de website
    (hierna “Website”).
    <br />
    <br />
    Door gebruik te maken van bepaalde functies van de Website, krijgt de
    Aanbieder je persoonsgegevens ter beschikking. Die worden verwerkt met
    respect voor je privacy, volgens de
    <a
      class="font-semibold text-brand underline decoration-brand/40 underline-offset-2 hover:decoration-brand"
      href="https://www.gegevensbeschermingsautoriteit.be/privacywet-en-uitvoeringsbesluiten"
      target="_blank"
      rel="noopener"
      >Belgische privacywet</a
    >
    en de Europese
    <a
      class="font-semibold text-brand underline decoration-brand/40 underline-offset-2 hover:decoration-brand"
      href="https://eur-lex.europa.eu/legal-content/NL/TXT/?uri=CELEX:32016R0679"
      target="_blank"
      rel="noopener"
      >Algemene Verordening Gegevensbescherming (AVG of GDPR)</a
    >.
    <br />
    <br />
    Wil je meer weten over privacy en gegevensbescherming, dan kan je terecht
    bij de
    <a
      class="font-semibold text-brand underline decoration-brand/40 underline-offset-2 hover:decoration-brand"
      href="https://www.gegevensbeschermingsautoriteit.be"
      target="_blank"
      rel="noopener"
      >Gegevensbeschermingsautoriteit</a
    >.
    <br />
    <br />
    Uw gegevens worden verwerkt omdat ze nodig zijn om uw account en uw
    reservaties uit te voeren (artikel 6.1.b AVG), en om te voldoen aan
    wettelijke verplichtingen (artikel 6.1.c AVG).
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Artikel 1: Voor wie geldt deze privacyverklaring?
    <br />
  </h2>
  <p class="text-left">
    Deze Privacyverklaring geldt voor alle potentiële, huidige en voormalige
    gebruikers van de Website.
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Artikel 2: Wie is verantwoordelijk voor de verwerking?
    <br />
  </h2>
  <p class="text-left">
    Joeri Gouwkens treedt op als verantwoordelijke voor de verwerking bij het
    verwerken van persoonsgegevens en dit voor wat betreft de verwerkingen die
    de Aanbieder op eigen verantwoordelijkheid en gezag verricht. Spinning
    Westerlo staat los van Heracles en van Perform2achieve BV: die verwerken uw
    gegevens niet en krijgen er geen toegang toe.
    <br />
    <br />
    Joeri Gouwkens<br />
    Ondernemingsnummer: BE 0875.763.609<br />
    Zetel: Verbrand Goor 33, 2230 Herselt<br />
    De lessen gaan door op: Boskant 14, 2260 Westerlo<br />
    Telefoonnummer: +3214545011<br />
    E-mailadres: joeri-gouwkens&#64;hotmail.com
  </p>
  <h2 class="text-lg font-semibold text-fg" id="artikel-3">
    Artikel 3: Welke persoonsgegevens worden verwerkt bij het gebruik van deze
    website?
    <br />
  </h2>
  <p class="text-left">
    Bij het aanmaken van uw account worden uw voornaam, achternaam, de
    weergavenaam die daaruit volgt, uw e-mailadres, chipnummer, of uw
    e-mailadres bevestigd is, of u beheerder bent, de datum waarop uw account is
    aangemaakt, en of het een proefles-account is en of die proefles al gebruikt
    is, bewaard. Bij elke reservering wordt bewaard welke les u reserveert, het
    aantal fietsen en het tijdstip van die les. Die gegevens zijn nodig om uw
    reservering uit te voeren.
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Artikel 4: Cookies
    <br />
  </h2>
  <p class="text-left">
    spinningwesterlo.be gebruikt geen cookies. Om u aangemeld te houden bewaart
    de website wel technische gegevens in uw browser (localStorage,
    sessionStorage en IndexedDB). Die zijn strikt noodzakelijk om de website te
    laten werken en worden gewist wanneer u zich afmeldt.
    <br />
    <br />
    Om te zien hoeveel mensen de website bezoeken en welke pagina's ze lezen,
    draait Cloudflare Web Analytics. Dat werkt zonder cookies en levert enkel
    geaggregeerde cijfers op, die niet tot u herleiden.
    <br />
    <br />
    Wilt u de route naar de zaal, dan opent de knop "Toon route" op de
    infopagina Google Maps in een nieuw venster. Pas op dat moment ontvangt
    Google gegevens van u, volgens zijn eigen beleid.
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Wie ontvangt mijn persoonsgegevens?
    <br />
  </h2>
  <p class="font-semibold">De Aanbieder</p>
  <p class="text-left">
    Persoonsgegevens en bedrijfsgegevens zoals aangegeven in Artikel 3.
  </p>
  <p class="font-semibold">Verwerkers</p>
  <p class="text-left">
    De Aanbieder doet een beroep op Google (Firebase) om de website te draaien,
    uw gegevens te bewaren en de bevestigingsmails te versturen, en op
    Cloudflare, waarlangs al het verkeer naar de site passeert en dat de
    bezoekcijfers bijhoudt. Beide treden op als verwerker in opdracht van De
    Aanbieder, onder een verwerkersovereenkomst, en mogen uw gegevens nooit op
    eigen initiatief gebruiken. De website en uw account- en reservatiegegevens
    staan op servers in de Europese Unie. Het aanmelden zelf verloopt via een
    dienst die Google in de Verenigde Staten draait; die doorgifte steunt op het
    EU-US Data Privacy Framework, waaronder Google gecertificeerd is, en op de
    standaardcontractbepalingen van de Europese Commissie.
  </p>
  <p class="font-semibold">Andere</p>
  <p class="text-left">
    Aan overheden en toezichthouders wanneer een wettelijke bepaling of een
    rechterlijke uitspraak De Aanbieder daartoe verplicht. Aan andere partijen
    worden uw persoonsgegevens niet doorgegeven zonder uw voorafgaande
    toestemming.
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Artikel 7: Hoelang worden mijn gegevens bijgehouden?
  </h2>
  <p class="text-left">
    De Aanbieder zal uw persoonlijke gegevens alleen bewaren voor de
    minimumperiode die nodig is om de, in deze Privacyverklaring uiteengezette,
    doeleinden te vervullen, tenzij bij het oplossen van geschillen of als een
    langere bewaartermijn wettelijk verplicht is. Niet-persoonlijke informatie
    kan zonder beperking in de tijd worden bewaard in functie van statistische
    doeleinden.
    <br />
    <br />
    Concreet: uw reservaties worden samen met de les verwijderd, 7 dagen nadat
    die les heeft plaatsgevonden. Uw account blijft bestaan zolang u het
    gebruikt. U kan het op elk moment zelf verwijderen bij Mijn gegevens; dan
    worden uw account, uw naam, uw e-mailadres en al uw reservaties gewist.
  </p>

  <h2 class="text-lg font-semibold text-fg">
    Artikel 8: Beveiliging en bewaring van persoonsgegevens
  </h2>
  <p class="text-left">
    De Aanbieder erkent dat de beveiliging van persoonsgegevens een onderdeel is
    van gegevensbescherming. Daardoor neemt De Aanbieder gepaste technische en
    organisatorische maatregelen om uw persoonsgegevens te beschermen tegen
    ongeoorloofde verwerking of ongeoorloofde toegang teneinde misbruik te
    voorkomen.
    <br />
    <br />
    Bij elke overdracht van persoonsgegevens aan een verwerker buiten de EER
    doet De Aanbieder dit steeds in overeenstemming met de voorwaarden van deze
    Privacyverklaring en volgt De Aanbieder de toepasselijke wet- en regelgeving
    inzake gegevensbescherming om afdoende waarborgen te garanderen.
  </p>

  <h2 class="text-lg font-semibold text-fg">
    Artikel 9: Hoe kan ik mijn rechten uitoefenen?
  </h2>

  <p class="text-left">
    Je kunt je rechten uitvoeren door een e-mail te sturen naar
    joeri-gouwkens&#64;hotmail.com. Om elke ongeoorloofde openbaarmaking van je
    persoonsgegevens te voorkomen, is het verplicht de aanvraag te sturen vanuit
    het e-mailadres dat gekoppeld is aan jouw account.
    <br />
    <br />
    De Aanbieder heeft één maand de tijd om je aanvraag te beantwoorden. Deze
    periode begint te lopen wanneer De Aanbieder je aanvraag heeft ontvangen en
    over alle vereiste informatie beschikt om aan je aanvraag te voldoen.
    <br />
    <br />
    De Aanbieder zal de gevraagde informatie kosteloos verstrekken. Wanneer
    verzoeken ongegrond of buitensporig zijn, met name vanwege hun repetitieve
    karakter, mag De Aanbieder een redelijke vergoeding aanrekenen of kan De
    Aanbieder het verzoek weigeren.
    <br />
    <br />
    Indien je om een of andere reden aanneemt dat De Aanbieder je aanvraag niet
    correct behandeld heeft, kan je contact opnemen met De Aanbieder waarna hij
    samen met jou op zoek gaat naar een oplossing.
    <br />
    <br />
    Voor de volledigheid: indien De Aanbieder niet reageert op je aanvraag, deze
    weigert of indien het antwoord niet voldoet aan je verwachtingen, je steeds
    het recht hebt een klacht neer te leggen bij de Commissie voor de
    Bescherming van de Persoonlijke Levenssfeer
    (Gegevensbeschermingsautoriteit), Drukpersstraat 35 te 1000 Brussel of via
    contact&#64;apd-gba.be.
  </p>
  <h2 class="text-lg font-semibold text-fg">
    Artikel 10: Welke rechten kan ik uitoefenen?
  </h2>
  <p class="text-left">
    Recht op inzage: Je kunt vragen welke persoonsgegevens van je verwerkt
    worden, waarvoor, welke categorieën van persoonsgegevens dat zijn, met welke
    categorieën van derden ze gedeeld worden, wat de oorsprong is van de
    verwerkte gegevens en, wanneer van toepassing, welke logica gebruikt wordt
    bij het automatisch verwerken van persoonsgegevens.
    <br />
    <br />
    Recht op rectificatie: Je past je e-mailadres en je wachtwoord zelf aan via
    "Mijn gegevens" in het profielmenu. Een wijziging van je e-mailadres
    bevestig je met een link die naar je nieuwe adres gestuurd wordt. Voer zelf
    elke wijziging door om je gegevens up-to-date te houden. Klopt je naam of je
    chipnummer niet, meld het dan via het e-mailadres in artikel 2.
    <br />
    <br />
    Recht op gegevenswissing: Je verwijdert je account zelf via "Mijn gegevens"
    in het profielmenu. Daarbij worden je login, je naam, je e-mailadres en al
    je reservaties definitief gewist, en komen de plaatsen die je nog had in
    komende lessen weer vrij. Hierdoor is het niet meer mogelijk De Website te
    gebruiken. Twee dingen blijven bestaan: het chipnummer zelf, dat toebehoort
    aan de club en aan een volgend lid toegewezen kan worden, en de
    deelnemersaantallen van lessen die al doorgingen, die geen persoonsgegeven
    meer zijn. Reservekopieën en de logbestanden van de verwerkers verdwijnen
    binnen hun eigen bewaartermijn.
    <br />
    <br />
    Recht op beperking van verwerking: in de gevallen die worden bepaald in
    Belgische en Europese privacywetgeving. Wanneer de verwerking binnen De
    Website beperkt is, worden uw persoonsgegevens (behalve voor opslag) alleen
    verwerkt met uw toestemming of voor de oprichting, uitoefening of
    verdediging van rechtsvorderingen of voor de bescherming van de rechten van
    een andere natuurlijke of rechtspersoon of om redenen van algemeen belang.
    Na het verkrijgen van deze beperking van verwerking, wordt u steeds door De
    Aanbieder op de hoogte gesteld voordat de beperking van de verwerking wordt
    opgeheven.
    <br />
    <br />
    Recht op overdraagbaarheid van de gegevens: U heeft het recht om de door u
    verstrekte persoonsgegevens in een gangbare, gestructureerde en machinaal
    leesbare vorm te verkrijgen en heeft het recht om deze persoonsgegevens over
    te dragen aan een andere verwerkingsverantwoordelijke waarbij de verwerking
    gebaseerd is op de rechtsgronden toestemming of contractuele relatie.
    <br />
    <br />
    Recht op terugtrekken van toestemming: Indien de verwerking van een
    persoonsgegevens gebaseerd is op de grondslag toestemming, heeft u als
    gebruiker te allen tijde het recht deze toestemming in te trekken. Dat kan
    door het opzeggen van uw account.
    <br />
    <br />
    Recht op bezwaar: U heeft het recht bezwaar te maken tegen de verwerking van
    uw persoonsgegevens enkel en alleen als de verwerking berust op algemeen
    belang of een gerechtvaardigd belang.
  </p>
  <p>Laatst bijgewerkt op 13/09/2026</p>
</div>
